import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';

import {getGlid, clicktracking, gatrack} from '../../utils';

import feature1 from '../../Images/productsimages/feature1.png'
import feature2 from '../../Images/productsimages/feature2.png'
import feature3 from '../../Images/productsimages/feature3.png'
import feature4 from '../../Images/productsimages/feature4.png'

const expandingIconStyle = {
    width: '56px',
    height: '56px',
    flexShrink: 0,
    borderRadius: '11.231px',
    background: '#EDF5FC',
    boxShadow: '0px 11.23077px 44.92308px 0px rgba(46, 49, 146, 0.04)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const iconsTextStyle = {
    color: '#091E42',
    fontFamily: 'Arial',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px'
};

const buttonstyle = {
    width: '199px',
    height: '54px',
    flexShrink: '0',
    borderRadius: '10.595px',
    background: 'var(--Brand1, #2E3192)',
    borderStyle: 'none',
    color: '#FFF',
    fontFamily: 'Arial',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    marginTop : '-10px'
};

const emiIconStyle = {
    width: '56px',
    height: '56px',
    flexShrink: '0',
    borderRadius: '11.231px',
    background: '#FCF1ED',
    boxShadow: '0px 11.23077px 44.92308px 0px rgba(46, 49, 146, 0.04)'
}

const tenureIconStyle = {
    width: '56px',
    height: '56px',
    flexShrink: '0',
    borderRadius: '11.231px',
    background: '#FCF9ED',
    boxShadow: '0px 11.23077px 44.92308px 0px rgba(46, 49, 146, 0.04)'
}

const pfeeicon = {
    width: '56px',
    height: '56px',
    flexShrink: '0',
    borderRadius: '11.231px',
    background: '#ECECEC',
    boxShadow: '0px 11.23077px 44.92308px 0px rgba(46, 49, 146, 0.04)'
}

const eligcriteria = {
    paddingTop:'35px',
    textTransform: 'capitalize',
    color: '#091E42',
    fontFamily: 'Arial',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '100%',
    textAlign:'left',
    paddingLeft:'32px',
    paddingBottom:'24px' 
}

const featuretextstyle = {
    marginBottom: '10px',
    color: '#626262',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '147.023%' 
}

const featurevaltextstyle = {
    color: '#091E42',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '147.023%'
}

const docstextstyle = {
    textAlign:'left', 
    marginLeft:'40px',
    color: '#091E42',
    fontFamily: 'Arial',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '186%' /* 33.48px */
}

function geturldata(vendor_name) {
    var glid = getGlid();

    var host = window.location.hostname;

    if (host == 'loans.indiamart.com') {
        var geturldataURL = "https://loans.indiamart.com/functions.php";
    }
    else {
        var geturldataURL = "https://dev-loans.indiamart.com/functions.php";
    }

    var geturldataPostData = {
        "functionName" : "geturldata",
        "glid": glid,
        "vendor_name": vendor_name
    };

    var formData = new FormData();
    for (var key in geturldataPostData) {
        formData.append(key, geturldataPostData[key]);
    }

    if (glid) {
        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: geturldataURL,
            data: formData,
            timeout: 10000
        }).then(function (response) {

            var data_obj = response['data'];

            window.open(data_obj.red_url, '_blank');

        })
    }
    else {
        if (vendor_name === "CreditEnable Unsecured") {
            window.open('https://www.creditenable.com/in/sme-business-loan/unsecured-business-loans/indiamart-sme-business-loans-v1?', '_blank');
        }
        else if (vendor_name === "CreditEnable Secured") {
            window.open('https://www.creditenable.com/in/sme-business-loan/unsecured-business-loans/indiamart-sme-business-loans-v1?', '_blank');
        }
        else if (vendor_name === "Pirimid") {
            window.open('https://indiamart.ignosis.ai/lsp/ui/api/indiamart/tenant/loan/init', '_blank');
        }
        else if (vendor_name === "CreditMantri") {
            window.open('https://www.creditmantri.com/Indiamart/?utm_content=alliance-lp&alliance_lender=Indiamart&utm_campaign=alliances&utm_source=Indiamart_CoBrandedPage&utm_term=alliance_indiamart', '_blank');
        }
        else if (vendor_name === "LoanTap") {
            window.open('https://loantap.in/journey/start/bl-im?', '_blank');
        }
        else if (vendor_name === "OneInfinity") {
            window.open('https://complementor.oneflo.in/complementor-widget/bil/CONN4128778344?', '_blank');
        }

    }

}



class ProductsComponent extends Component
{
    logincheck = (vendor_name, vendor_url) =>
    {
        var glid = getGlid();

        if(!glid)
        {
            window.open(vendor_url,'_blank');
        }
        else
        {
            geturldata(vendor_name);
            gatrack('Apply for loan',vendor_name,'Click');
            clicktracking(vendor_name);
        }
        
    }

    render()
    {
        return (
            <>
            <div className='container sec07 text-center' style={{paddingTop:'65px'}}>
                <div className='row' style={{marginLeft:'10px'}}>
                    <div className='col-12' style={{textAlign:'left', paddingBottom:'48px'}}>
                        <span>Types of Products</span>
                    </div>
                </div>

                <section style={{background:'#F5FAFF', paddingBottom:'50px'}} >

                    <div className='row' style={{border: '1px #2E3192', borderStyle: 'none none solid none',paddingTop:'59px', textAlign:'left', paddingLeft:'40px', marginLeft:'15px', marginRight:'10px'}}>
                        <div className='col-6 productname' style={{paddingBottom:'35px' , marginLeft:'-40px'}}>
                        <strong>Unsecured Business Loans</strong>
                        </div>
                        <div className='col-6' style={{textAlign:'right'}}>
                            <button style={buttonstyle} onClick={() => this.logincheck('OneInfinity', 'https://complementor.oneflo.in/complementor-widget/bil/CONN4128778344?')}>Apply Now</button>
                        </div>
                    </div>
                    <div style={{ marginTop: '32px' }}>

                            <div className="container" style={{paddingLeft:'30px'}}>
                                <div className="row">
                                    <div className="col-lg-3">
                                        <div className="d-flex" style={{textAlign:'left'}}>
                                            <div style={expandingIconStyle}>
                                                <img src={feature1} alt="Int Rate Icon" />
                                            </div>
                                            <div className="ml-2" style={{ ...iconsTextStyle, marginLeft: '16px' }}>
                                                Interest Rate:<br/> <strong style={{display:'flex'}}><div style={{marginRight:'3px',fontSize:'16px',position:'relative',top:'1px'}}>Starts</div> @ 15%</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="d-flex " style={{textAlign:'left'}}>
                                            <div style={emiIconStyle}>
                                                <img src={feature2} alt="EMI Icon" style={{paddingTop:'8px'}}/>
                                            </div>
                                            <div className="ml-2" style={{ ...iconsTextStyle, marginLeft: '16px' }}>
                                                EMI/Lakh: <br/> <strong style={{display:'flex'}}><div style={{marginRight:'3px',fontSize:'16px',position:'relative',top:'1px'}}>Starts</div> @ ₹3000</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="d-flex " style={{textAlign:'left'}}>
                                            <div  style={tenureIconStyle}>
                                                <img src={feature3} alt="Tenure Icon" style={{paddingTop:'8px'}}/>
                                            </div>
                                            <div className="ml-2" style={{ ...iconsTextStyle, marginLeft: '16px' }}>
                                                    Tenure: <br/> <strong>Min. 2 years</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="d-flex " style={{textAlign:'left'}}>
                                            <div style={pfeeicon}>
                                                <img src={feature4} alt="PPfees Icon" style={{paddingTop:'8px'}}/>
                                            </div>
                                            <div className="ml-2" style={{ ...iconsTextStyle, marginLeft: '16px',whiteSpace:'nowrap' }}>
                                                Processing Fee: <br /> <strong style={{ display: 'flex' }}><div style={{ marginRight: '3px', fontSize: '16px', position: 'relative', top: '1px' }}>Starts</div> @ 2%</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    <div style={{marginTop:'40px', marginLeft:'40px',background: '#D5E4F2',borderRadius: '16px', paddingBottom:'32px', marginRight:'40px'}}>
                            <div style={eligcriteria}>
                                Eligibility Criteria
                            </div>

                            <div>
                            <div className="container" style={{paddingLeft:'30px'}}>
                                <div className="row">
                                    <div className="col-lg-3">
                                    <div className="d-flex flex-column" style={{textAlign:'left'}}>
                                        <div style={featuretextstyle}>Age</div>
                                        <div style={featurevaltextstyle}>Minimum 21 years</div>
                                    </div>

                                    </div>
                                    <div className="col-lg-3">
                                    <div className="d-flex flex-column" style={{textAlign:'left'}}>
                                        <div style={featuretextstyle}>Business Vintage</div>
                                        <div style={featurevaltextstyle}>Minimum 1 year</div>
                                    </div>
                                    </div>
                                    <div className="col-lg-3">
                                    <div className="d-flex flex-column" style={{textAlign:'left'}}>
                                        <div style={featuretextstyle}>Annual Turnover</div>
                                        <div style={featurevaltextstyle}>Minimum ₹50 lakh yearly</div>
                                    </div>
                                    </div>
                                    <div className="col-lg-3">
                                    <div className="d-flex flex-column" style={{textAlign:'left'}}>
                                        <div style={featuretextstyle}>Cibil Score</div>
                                        <div style={featurevaltextstyle}>650 & above</div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                    </div>

                    <div style={{marginTop:'0px'}}>
                    <div style={eligcriteria}>
                                Required Documents
                            </div>
                    <div style={docstextstyle}>
                     <li>KYC details of applicant & co applicant</li>
                     <li>Residence light Bill for applicant, co applicant & Office address proof (Latest Electricity Bill)</li> 
                     <li>GST Certificate and Udyam Certificate</li>  
                     <li>Last 12 months Bank statement of all accounts </li>   
                     <li>GST Return 3B (Last 12 months) </li>     
                     <li>All running loans sanction letters</li>   
                    </div>    
                    </div>


                </section>

                
                </div>    
            </>


        );
    }
}

export default ProductsComponent;